/**
 * Utility function for downloading files from the API
 * Uses fetchBlob to properly handle authentication and workspace headers
 */

import { fetchBlob } from '@/api/mutator/custom-instance';

export const downloadFile = async (fileId: string | number, fileName?: string) => {
  try {
    // Use relative URL - axios instance already has baseURL configured
    const apiUrl = `/files/uploads/${fileId}/`;

    console.log('🔽 Downloading file:', { fileId, fileName, apiUrl });

    const blob = await fetchBlob(apiUrl);

    console.log('✅ Blob received:', { size: blob.size, type: blob.type });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName || `file_${fileId}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    console.log('✅ Download complete');
  } catch (error) {
    console.error('❌ Error downloading file:', error);
    alert(`Failed to download file: ${error}`);
  }
};
